import React from "react";
import { t } from "ttag";

import { CardModalBlock as Value } from "@reactivated";

import { CenteredModalControlled } from "../CenteredModal";
import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichTextStreamBlock } from "../RichTextStreamBlock";

import styles from "./CardModal.module.scss";

type ModalItem = NonNullable<Value["content"]>[number];

interface Props {
    value: Value;
    isOpen: boolean;
    onClose: () => void;
    label?: string;
}

export const CardModal = ({ value, isOpen, onClose, label }: Props) => {
    const content = value.content ?? [];
    const media = content.find(
        (block): block is Extract<ModalItem, { type: "media" }> =>
            block.type === "media",
    );
    const text = content.find(
        (block): block is Extract<ModalItem, { type: "rich_text_stream" }> =>
            block.type === "rich_text_stream",
    );

    return (
        <CenteredModalControlled
            isOpen={isOpen}
            onOpenChange={(open) => {
                if (!open) onClose();
            }}
            theme={value.theme ?? "offWhite"}
            panelClassName={styles.panel}
            label={label ?? t`Card details`}
        >
            {media && (
                <MediaChooserBlock
                    value={media.value}
                    wrapperAttrs={{ className: styles.media }}
                    imageProps={{
                        sizes: text ? styles.sizes : styles.sizesFull,
                    }}
                />
            )}
            {text && (
                <div className={styles.text}>
                    <RichTextStreamBlock value={text.value} />
                </div>
            )}
        </CenteredModalControlled>
    );
};
